export const avatarFile = 'avatarFile';
